<template>
  <div
      v-loading="loading"
      class="containerInfo"
      element-loading-text="数据加载中……"
      element-loading-spinner="el-icon-loading"
  >
    <el-row type="flex" justify="space-around">
      <el-col :lg="14" :sm="24" :xs="24">
        <el-card class="box-card">
          <div slot="header" class="clearfix" style="font-weight: bold;display: flex; align-items: center;">
            <img src="@/assets/recruit/juxing.png" alt="Logo" style="margin-right: 12px;"/>
            <span><b>其他信息</b> </span>
          </div>
          <el-form ref="postForm" :model="form" label-width="100px" :rules="rules">
            <el-row v-if="!isMb">
              <el-col :span="12">
                <el-form-item
                    label="是否应届生:"
                    prop="education.freshGraduate"
                    :required="isRequired"
                >
                  <el-col :span="10">
                    <zr-combobox
                        v-model="form.education.freshGraduate"
                        placeholder="是否应届生"
                        :data-array="[
                        { name: '是', code: '是' },
                        { name: '否', code: '否' },
                      ]"
                        value-field="code"
                        label-field="name"
                        style="width: 135px"
                        clearable
                    ></zr-combobox>
                  </el-col>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="计算机等级:" prop="education.programLevel">
                  <el-col :span="24"
                  ><el-input
                      v-model="form.education.programLevel"
                      maxlength="20"
                      placeholder="计算机/程序员等级（注明全国/地区）"
                      clearable
                  ></el-input
                  ></el-col>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="isMb">
              <el-col :span="12">
                <el-form-item
                    label="是否应届生:"
                    prop="education.freshGraduate"
                    :required="isRequired"
                >
                  <el-col :span="10">
                    <zr-combobox
                        v-model="form.education.freshGraduate"
                        placeholder="是否应届生"
                        :data-array="[
                        { name: '是', code: '是' },
                        { name: '否', code: '否' },
                      ]"
                        value-field="code"
                        label-field="name"
                        style="width: 135px"
                        clearable
                    ></zr-combobox>
                  </el-col>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="isMb">
              <el-col :span="12">
                <el-form-item label="计算机等级:" prop="education.programLevel">
                  <el-col :span="24"
                  ><el-input
                      v-model="form.education.programLevel"
                      maxlength="20"
                      placeholder="计算机/程序员等级（注明全国/地区）"
                      clearable
                  ></el-input
                  ></el-col>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item
                v-if="isTechnique"
                label="国家职业资格:"
                prop="education.professionLevel"
            >
              <el-col :span="24">
                <el-input
                    v-model="form.education.professionLevel"
                    clearable
                    type="textarea"
                    maxlength="300"
                    show-word-limit
                    :rows="2"
                    :autosize="{ minRows: 2, maxRows: 20 }"
                    placeholder="国家职业资格等级"
                ></el-input
                ></el-col>
            </el-form-item>
            <el-form-item
                label="主干课程:"
                prop="education.course"
                :required="isRequired"
            >
              <el-col :span="24">
                <el-input
                    v-model="form.education.course"
                    clearable
                    type="textarea"
                    maxlength="300"
                    show-word-limit
                    :rows="2"
                    :autosize="{ minRows: 2, maxRows: 20 }"
                    placeholder="主干课程"
                ></el-input
                ></el-col>
            </el-form-item>
            <el-form-item
                label="科研方向(专科，本科填写专业):"
                prop="education.researchOrientation"
            >
              <el-col :span="24">
                <el-input
                    v-model="form.education.researchOrientation"
                    clearable
                    type="textarea"
                    maxlength="100"
                    show-word-limit
                    :rows="4"
                    :autosize="{ minRows: 2, maxRows: 20 }"
                    placeholder="最高科研方向"
                ></el-input
                ></el-col>
            </el-form-item>
            <el-form-item
                label="代表性学术成果(文章专利):"
                prop="education.achievement"
            >
              <el-col :span="24">
                <el-input
                    v-model="form.education.achievement"
                    clearable
                    type="textarea"
                    maxlength="1000"
                    show-word-limit
                    :rows="4"
                    :autosize="{ minRows: 4, maxRows: 20 }"
                    placeholder="刊物名称、作者排名、影响因子、文章分区"
                ></el-input
                ></el-col>
            </el-form-item>
            <el-form-item label="高校获奖情况:" prop="education.prizeCase">
              <el-col :span="24">
                <el-input
                    v-model="form.education.prizeCase"
                    clearable
                    type="textarea"
                    maxlength="1000"
                    show-word-limit
                    :rows="4"
                    :autosize="{ minRows: 4, maxRows: 20 }"
                    placeholder="校级综合奖学金、国际/国家/省部/赛区级的科技比赛获奖、科技进步奖、技术发明奖、自然科学奖等（务必注明有无证书原件）"
                ></el-input
                ></el-col>
            </el-form-item>
            <el-row>
              <el-col :span="24">
                <el-form-item
                    v-if="isTechnique"
                    label="技能大赛获奖类别:"
                    prop="education.winAwardType"
                    :required="isRequired"
                >
                  <el-col :span="10">
                    <zr-combobox
                        v-model="form.education.winAwardType"
                        :data-array="[
                        { name: '国赛', code: '国赛' },
                        { name: '省赛', code: '省赛' },
                        { name: '其他', code: '其他' },
                      ]"
                        value-field="code"
                        label-field="name"
                        style="width: 135px"
                        clearable
                    ></zr-combobox>
                  </el-col>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item
                v-if="isTechnique"
                label="技能大赛获奖等级:"
                prop="education.winAwardLevel"
                :required="isRequired"
            >
              <el-col :span="24">
                <el-input
                    v-model="form.education.winAwardLevel"
                    clearable
                    type="textarea"
                    maxlength="255"
                    show-word-limit
                    placeholder="技能大赛获奖等级(没有填写无)"
                    :rows="4"
                ></el-input
                ></el-col>
            </el-form-item>
            <el-form-item
                v-if="isTechnique"
                label="技能大赛获奖名称:"
                prop="education.winAwardName"
                :required="isRequired"
            >
              <el-col :span="24">
                <el-input
                    v-model="form.education.winAwardName"
                    clearable
                    type="textarea"
                    maxlength="255"
                    show-word-limit
                    placeholder="技能大赛获奖名称(没有填写无)"
                    :rows="4"
                ></el-input
                ></el-col>
            </el-form-item>
            <el-form-item
                v-if="isTechnique"
                label="技能大赛获奖名次:"
                prop="education.winAwardRank"
                :required="isRequired"
            >
              <el-col :span="24">
                <el-input
                    v-model="form.education.winAwardRank"
                    clearable
                    type="textarea"
                    maxlength="255"
                    show-word-limit
                    placeholder="技能大赛获奖名次(没有填写无)"
                    :rows="4"
                ></el-input
                ></el-col>
            </el-form-item>
            <el-form-item label="学生工作社团组织:" prop="education.massCase">
              <el-col :span="24">
                <el-input
                    v-model="form.education.massCase"
                    clearable
                    type="textarea"
                    maxlength="1000"
                    show-word-limit
                    :rows="4"
                    :autosize="{ minRows: 4, maxRows: 20 }"
                    placeholder="学生工作社团组织"
                ></el-input
                ></el-col>
            </el-form-item>
            <el-form-item label="自我评价及其他说明:" prop="education.remark">
              <el-col :span="24">
                <el-input
                    v-model="form.remark"
                    clearable
                    type="textarea"
                    maxlength="1000"
                    show-word-limit
                    :rows="4"
                    :autosize="{ minRows: 4, maxRows: 20 }"
                    placeholder="自我评价及其他说明。如选择我所原因，实践活动要求。"
                ></el-input
                ></el-col>
            </el-form-item>
            <el-checkbox v-model="form.education.promise" true-label="是" false-label="否" style="margin-bottom: 10px;">本人承诺：所提供信息真实准确，若有造假，本人愿意承担不实承诺相关责任！</el-checkbox>

            <!-- 个人简历附件上传 - 修改为投递前即可选择但不立即上传 -->
            <el-card v-if="isPost || isView">
              <el-upload
                  ref="upload1"
                  title="上传个人简历附件"
                  :headers="headers"
                  :action="uploadAction1"
                  :on-preview="handleDownload"
                  :on-change="handleChange1"
                  :on-exceed="handleExceed1"
                  :before-remove="beforeRemove"
                  :on-remove="handleRemove1"
                  :on-success="uploadSucceed1"
                  :file-list="form.fileList1"
                  :limit="1"
                  :auto-upload="false"
              >
                <el-button v-if="!isView" size="small" type="primary"
                >上传个人简历附件</el-button><span v-if="!isView" style="color: gray">
               <font style="color: red;">*</font> 个人简历栏<span style="color: red;">（个人简历必传，请在投递简历前先上传个人简历附件,仅支持上传pdf，限上传一份）</span>
              </span>
              </el-upload>
            </el-card>

            <!-- 其他附件上传 - 保持投递后上传 -->
            <el-card v-if="isPost || isView">
              <el-upload
                  ref="upload"
                  title="其他附件上传"
                  :headers="headers"
                  :action="uploadAction"
                  :on-preview="handleDownload"
                  :before-upload="beforeUpload"
                  :on-exceed="handleExceed"
                  :before-remove="beforeRemove"
                  :on-remove="handleRemove"
                  :on-success="uploadSucceed"
                  :file-list="form.fileList"
              >
                <el-button v-if="!isView" size="small" type="primary"
                >其他附件上传</el-button
                ><span v-if="!isView" style="color: gray">
               如：四六级证书，成绩单，获奖证书等<span  style="color: red;">(投递后再上传其他附件)</span>
              </span>
              </el-upload>
            </el-card>

            <div style="text-align: center">
              <slot name="footBtn" :form="form">
                <el-button icon="el-icon-circle-back" @click="preActive"
                >上一步
                </el-button
                >
                <el-button
                    v-if="!isView && loginUser && !isPost"
                    icon="el-icon-circle-check"
                    type="primary"
                    @click="doSave"
                >保存
                </el-button
                >
                <el-button
                    v-if="
                    !isView &&
                    loginUser &&
                    (isProfessionTech || isTechnique) &&
                    isPost
                  "
                    icon="el-icon-circle-check"
                    type="success"
                    @click="doSave"
                >投递简历
                </el-button
                >
                <el-button icon="el-icon-back" plain @click="back"
                >返回
                </el-button
                >
              </slot>
            </div>
          </el-form>
        </el-card>
      </el-col>
    </el-row
    >
    <research-dialog
        v-if="showResearchModal"
        ref="researchRef"
        :research-orientations="researchOrientations"
        @confirm="onResear"
        :is-mb="isMb"
    ></research-dialog>
  </div>
</template>

<script>
import researchDialog from "@/views/recruit/applicant/researchDialog.vue";
import {mapGetters} from "vuex";
import isMobile from "@/utils/device";
import {getBasicData} from "@/api/job/postInfo";
import settingHelp from "@/config/localSetting";
import store from "@/store";
import {downloadFile} from "@/utils/downFile";
import {messageDuration} from "@/config/settings";
import {
  saveResumeInfo,
} from "@api/recruit/user/resume";
import {deleteFileById} from "@/api/recruit/user/upload";
import axios from "axios";

const config = settingHelp.getConfig();
const {remoteURL} = config;
const token1 = localStorage.getItem("token");
const token2 = store.getters["user/accessToken"];
const token = token2 ? token2 : token1;

// 新增：创建 axios 实例
const httpUpload = axios.create({
  baseURL: remoteURL,
});
httpUpload.interceptors.request.use((config) => {
  const uploadToken = store.getters["user/accessToken"];
  if (uploadToken) {
    config.headers["Authorization"] = `${uploadToken}`;
  }
  return config;
});

export default {
  name: "PersonalEducationInfo",
  components: {researchDialog},
  props: {
    form: {
      type: Object,
      default() {
        return {};
      },
    },
    isPost: {
      type: Boolean,
      default: false,
    },
    isRequired: {
      type: Boolean,
      default: true,
    },
    isView: {
      type: Boolean,
      default: false,
    },
    isTechnique: {
      type: Boolean,
      default: false,
    },
    isProfessionTech: {
      type: Boolean,
      default: false,
    },
    positionInfoId: {
      type: String,
    },
    researchOrientations: {
      type: String,
    },
  },
  data() {
    return {
      uploadAction: "",
      uploadAction1: "",
      headers: {Authorization: token},
      showResearchModal: false,
      isMb: false,
      postSendId: "",
      curI: null,
      loading: false,
      loginUser: {},
      // 存储待上传的个人简历文件（已选择但未投递的文件）
      pendingUploadFiles1: [],
      languageInfoColumns: [
        {name: "语言语种", code: "languageClass", needDrawCell: true},
        {
          name: "证书",
          code: "languageCertificate",
          needDrawCell: true,
        },
        {name: "证书成绩", code: "languageScore", needDrawCell: true},
        {name: "操作", code: "operate", needDrawCell: true},
      ],
      rules: {
        languageScore: [
          {required: true, message: "请输入证书成绩", trigger: "blur"},
        ],
      }
    };
  },
  computed: {
    ...mapGetters({
      userPhone: "user/userPhone",
      userName: "user/userName",
      userCode: "user/userCode",
    }),
  },
  async created() {
    this.loading = true;
    this.isMb = await isMobile();
    if (this.$route.query.isView) {
      this.isView = true;
      this.isRequired = false;
    }
    if (this.form.postSendId) this.postSendId = this.form.postSendId;
    if (this.form.isProfessionTech)
      this.isProfessionTech = this.form.isProfessionTech;
    if (this.form.isTechnique) this.isTechnique = this.form.isTechnique;
    this.loading = false;
    if (!this.$route.query.postSendId) {
      this.loginUser = {name: this.userName, id: this.userPhone};
    }
    this.form.languageInfoList.forEach((item) => {
      if (item.languageClass === "英语") {
        item.showDic = true;
      }
    })
  },
  methods: {
    // 附件下载
    handleDownload(file) {
      const token = store.getters["user/accessToken"];
      downloadFile("/comm/file/downloadFile", {id: file.id, token: token});
    },
    beforeRemove(file, fileList) {
      if (file.id) {
        return this.$confirm(`确定要删除文件：${file.name}?`);
      }
    },

    // 个人简历附件删除
    handleRemove1(file, fileList) {
      if (file.id) {
        // 删除已上传到服务器的文件
        deleteFileById({id: file.id})
            .then((result) => {
              if (result.code === 200 && result.success) {
                  this.form.fileList1.splice(0, 1);
                fileList.splice(
                    fileList.findIndex((item) => item.fileId === file.fileId),
                    1
                );
              } else {
                this.$message.warning(result.message);
              }
            })
            .catch((err) => {
              console.log(err);
            });
      } else {
        // 从待上传队列中移除
        const index = this.pendingUploadFiles1.findIndex(item => item.uid === file.uid);
        if (index > -1) {
          this.pendingUploadFiles1.splice(index, 1);
        }
      }
    },

    // 其他附件删除（保持原有逻辑）
    handleRemove(file, fileList) {
      if (file.id) {
        deleteFileById({id: file.id})
            .then((result) => {
              if (result.code === 200 && result.success && result.data === "文件删除成功") {
                fileList.splice(
                    fileList.findIndex((item) => item.fileId === file.fileId),
                    1
                );
              } else {
                this.$message.warning(result.message);
              }
            })
            .catch((err) => {
              console.log(err);
            });
      }
    },

    // 【核心修改】：使用 on-change 钩子捕获文件选择
    handleChange1(file, fileList) {
      // 文件被移除时不处理
      if (file.status === 'removed') {
        return;
      }

      // 检查是否是新增的文件（新选择的文件没有 id 属性）
      if (!file.id && file.raw) {
        // 文件格式校验
        const isDoc = file.raw.type === "application/pdf"
        if (!isDoc) {
          this.$message.error("上传的个人简历附件只能是 pdf 格式!");
          // 移除不合格的文件
          const idx = fileList.findIndex(f => f.uid === file.uid);
          if (idx > -1) {
            fileList.splice(idx, 1);
          }
          return;
        }

        // 文件大小校验
        const isLt50M = file.raw.size / 1024 / 1024 < 50;
        if (!isLt50M) {
          this.$message.error("上传附件大小不能超过 50MB!");
          // 移除不合格的文件
          const idx = fileList.findIndex(f => f.uid === file.uid);
          if (idx > -1) {
            fileList.splice(idx, 1);
          }
          return;
        }

        // 格式和大小校验通过，将文件添加到待上传队列
        // 先检查是否已经存在（避免重复添加）
        const exists = this.pendingUploadFiles1.some(f => f.uid === file.uid);
        if (!exists) {
          this.pendingUploadFiles1.push(file.raw);
          console.log('文件已添加到待上传队列:', file.name);
          console.log('pendingUploadFiles1 当前内容:', this.pendingUploadFiles1);
        }
      }
    },

    // 其他附件上传前的校验（保持投递后上传的逻辑）
    beforeUpload(file) {
      const isDoc =
          file.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
          file.type === "application/pdf" ||
          file.type === "application/zip" ||
          file.type === "application/vnd.ms-powerpoint" ||
          file.type === "image/png" ||
          file.type === "image/jpg" ||
          file.type === "image/gif" ||
          file.type === "image/jpeg";
      if (!isDoc) {
        this.$message.error("上传附件只能是 word,pdf,ppt,jpg,jpeg,png,gif 格式!");
        return false;
      }
      const isLt50M = file.size / 1024 / 1024 < 50;
      if (!isLt50M) {
        this.$message.error("上传附件大小不能超过 50MB!");
        return false;
      }
      const isPost = this.uploadAction.length > 0;
      if (!isPost) {
        this.$message.error("请先投递后再上传附件!");
        return false;
      }
      return isDoc && isLt50M && isPost;
    },

    handleExceed1(files, fileList1) {
      this.$message.warning(`当前限制选择 1 个文件，本次选择了${files.length}个文件`);
    },

    handleExceed(files, fileList) {
      this.$confirm(
          `当前限制选择 5 个文件，本次选择了${files.length}个文件，共选择了${
              files.length + fileList.length
          }个文件`
      );
    },

    // 个人简历上传成功回调
    uploadSucceed1(response) {
      if (response.code !== 200 || !response.success || response.message !== "成功") {
        this.$message.warning(response.message);
        return;
      }
      this.$message.success({
        showClose: true,
        message: "个人简历附件上传成功!",
        duration: messageDuration,
      });
    },

    // 其他附件上传成功回调
    uploadSucceed(response) {
      if (response.code !== 200 || !response.success || response.message !== "成功") {
        this.$message.warning(response.message);
        return;
      }
      this.$message.success({
        showClose: true,
        message: "附件上传成功!",
        duration: messageDuration,
      });
    },

    preActive() {
      this.$emit("preActive");
    },

    dataToForm(data) {
      this.form = {...this.form, ...data.formData};
    },

    checkResumeInfo(data) {
      if (this.isProfessionTech || this.isTechnique) {
        let course = data.education.course;
        if (!course) {
          this.$message.warning("请填写 [主要课程]！");
          return false;
        }
        let freshGraduate = data.education.freshGraduate;
        if (!freshGraduate && this.isProfessionTech) {
          this.$message.warning("请选择 [是否应届生]！");
          return false;
        }
      }
      return true;
    },

    back() {
      this.$router.back();
    },

    // 【核心方法】：投递成功后上传待上传的个人简历附件
    // 【核心方法】：投递成功后上传待上传的个人简历附件
    async uploadPendingResumeFiles(postSendId) {
      if (!this.pendingUploadFiles1 || this.pendingUploadFiles1.length === 0) {
        console.log('没有待上传的个人简历附件');
        return;
      }

      const uploadUrl = "/comm/file/uploadFileSelf?postSendId=" + postSendId;

      for (const file of this.pendingUploadFiles1) {
        try {
          const formData = new FormData();
          formData.append('file', file);

          let result = await httpUpload.request({
            url: uploadUrl,
            method: "POST",
            data: formData,
          });

          if (result.data && result.data.code === 200 && result.data.success) {
            console.log('个人简历附件上传成功:', file.name);
          } else {
            console.error('个人简历附件上传失败:', file.name, result);
            this.$message.error(`个人简历附件「${file.name}」上传失败`);
          }
        } catch (error) {
          console.error('个人简历附件上传失败:', file.name, error);
          this.$message.error(`个人简历附件「${file.name}」上传失败`);
        }
      }

      // 清空待上传队列
      this.pendingUploadFiles1 = [];

      this.$message.success({
        showClose: true,
        message: "个人简历附件已自动上传!",
        duration: messageDuration,
      });
    },

    async onResear(data) {
      this.form.education = {
        ...this.form.education,
        postOrientations: data.postOrientations,
        otherOrientations: data.otherOrientations,
      };
      try {
        this.loading = true;

        let res = await saveResumeInfo({
          formData: JSON.stringify(this.form),
          experienceList: JSON.stringify(this.form.experienceList),
          degreeList: JSON.stringify(this.form.degreeList),
          practiceLive: JSON.stringify(this.form.parcticeLiveList),
          familyInfo: JSON.stringify(this.form.familyInfo),
          workLive: JSON.stringify(this.form.workLiveList),
          projectLive: JSON.stringify(this.form.projectLiveList),
          languageInfo: JSON.stringify(this.form.languageInfoList),
          positionInfoId: this.$route.query.positionInfoId,
          userPhone: this.userPhone,
        });

        if (res.success) {
          this.$message.success({
            showClose: true,
            message: "投递成功",
            duration: messageDuration,
          });

          this.dataToForm(res.data);
          this.postSendId = res.data.postSendId;

          if (this.postSendId) {
            this.uploadAction = remoteURL + "/comm/file/uploadFile?postSendId=" + this.postSendId;
            this.uploadAction1 = remoteURL + "/comm/file/uploadFileSelf?postSendId=" + this.postSendId;

            // 【核心修改】：投递成功后，自动上传待上传的个人简历附件
            await this.uploadPendingResumeFiles(this.postSendId);
          }
        } else {
          this.$message.error(res.data);
        }
      } finally {
        this.loading = false;
      }
    },

    openSreash() {
      this.showResearchModal = true;
      this.$nextTick(() => {
        this.$refs.researchRef.showDialog(this.form.education);
      });
    },

    // 保存/投递简历
    async doSave() {
      if (!this.checkResumeInfo(this.form)) return;

      this.$refs.postForm.validate(async (valid) => {
        if (!valid) return;

        if (!this.form.education.promise || this.form.education.promise === '否') {
          this.$message.warning("请勾选本人承诺！");
          return;
        }

        var isPass = "0";
        await this.$emit('childDataChecks', (result) => {
          isPass = result
        })

        if (isPass === "1") {
          this.$message.warning("【教育背景】存在必填项未填写！");
          return false;
        } else if (isPass === "2") {
          this.$message.warning("【工作经历】存在必填项未填写！");
          return false;
        }

        // 【核心修改】：投递简历前，校验个人简历附件是否存在
        console.log("this.form.fileList1", this.form.fileList1);
        console.log("pendingUploadFiles1", this.pendingUploadFiles1);

        // 检查已上传的文件（有 id 属性的）
        const hasUploadedFile = this.form.fileList1 && this.form.fileList1.some(f => f.id);
        // 检查待上传的文件
        const hasPendingFile = this.pendingUploadFiles1 && this.pendingUploadFiles1.length > 0;

        if(this.isPost || this.isView) {
          if (!hasUploadedFile && !hasPendingFile) {
            this.$message.warning("请先上传个人简历附件后再投递简历！");
            return;
          }
        }

        this.form.education.degreeName = this.form.topDegreeName
        if (Array.isArray(this.form.placeOfOrigin)) {
          this.form.placeOfOrigin = this.form.placeOfOrigin.join(",")
        }
        if (Array.isArray(this.form.nativePlace)) {
          this.form.nativePlace = this.form.nativePlace.join(",")
        }
        if (Array.isArray(this.form.birthdayLocal)) {
          this.form.birthdayLocal = this.form.birthdayLocal.join(",")
        }

        // 保存模式（不投递）
        if (!this.isView && this.loginUser && !this.isPost) {
          try {
            this.loading = true;
            let res = await saveResumeInfo({
              formData: JSON.stringify(this.form),
              experienceList: JSON.stringify(this.form.experienceList),
              degreeList: JSON.stringify(this.form.degreeList),
              familyInfo: JSON.stringify(this.form.familyInfo),
              practiceLive: JSON.stringify(this.form.parcticeLiveList),
              workLive: JSON.stringify(this.form.workLiveList),
              projectLive: JSON.stringify(this.form.projectLiveList),
              languageInfo: JSON.stringify(this.form.languageInfoList),
            });

            if (res.success) {
              this.$message.success({
                showClose: true,
                message: "保存成功",
                duration: messageDuration,
              });
              this.dataToForm(res.data);
            } else {
              this.$message.error(res.data);
            }
          } finally {
            this.loading = false;
          }
        } else {
          // 投递模式
          this.openSreash();
        }
      });
    },

    addLanguageInfo() {
      const newRow = {
        id: this.form.languageInfoList.length + 1,
        isEdit: true,
      };
      this.form.languageInfoList.push(newRow);
    },

    delLanguageInfo(row) {
      const index = this.form.languageInfoList.findIndex((e) => e.id === row.id);
      if (index !== -1) {
        this.form.languageInfoList.splice(index, 1);
      }
    },
  },
};
</script>

<style scoped>
.tip-class {
  background: #f3f9ff;
  border: 1px solid #69b7ff;
  padding: 10px;
  border-radius: 2px;
  margin: 15px;
}

.icon-color {
  color: #1890ff;
}

.containerInfo {
  background-color: #f6f8f9;
  border-color: #f6f8f9;
}
</style>
